/* Jane Lushka v1.2 homepage reviews band loader (phase 6, N7; pattern of jl-pdp-below.js:40-125).
   Each [data-jl-reviews-mount]: within 200px of the viewport (IntersectionObserver; without it, on load) the
   Reviews.io script (data-script) and its stylesheets (data-styles) load once, then carouselInlineWidget(mount.id,
   options from the section's [data-jl-reviews-options] JSON) runs once. Auto scroll off under reduced motion.
   Blocked or failing: the heading and the reserved box stay, nothing is logged. defer; re-runs on section load. */
(function () {
  'use strict';

  if (window.JLHomeMid) return;
  window.JLHomeMid = true;

  var scriptPromise = null;

  function addStylesheet(href) {
    if (!href) return;
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href') === href) return;
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadScript(src) {
    if (typeof window.carouselInlineWidget === 'function') return Promise.resolve();
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      if (!src) { reject(new Error('no script')); return; }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () {
        if (typeof window.carouselInlineWidget === 'function') resolve();
        else reject(new Error('no widget'));
      };
      s.onerror = function () {
        scriptPromise = null;
        reject(new Error('blocked'));
      };
      document.head.appendChild(s);
    });
    return scriptPromise;
  }

  function start(mount) {
    if (!mount || mount.__jlStarted) return;
    mount.__jlStarted = true;

    var holder = mount.parentNode;
    var json = holder && holder.querySelector('[data-jl-reviews-options]');
    var options;
    try {
      options = JSON.parse(json ? json.textContent : '');
    } catch (e) {
      return;
    }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      options.options = options.options || {};
      options.options.general = options.options.general || {};
      options.options.general.enable_auto_scroll = false;
    }

    (mount.getAttribute('data-styles') || '').split(/\s+/).forEach(addStylesheet);

    loadScript(mount.getAttribute('data-script')).then(function () {
      if (mount.getAttribute('data-jl-reviews') === 'ready') return;
      try {
        new window.carouselInlineWidget(mount.id, options);
        mount.setAttribute('data-jl-reviews', 'ready');
      } catch (e) {
        mount.setAttribute('data-jl-reviews', 'failed');
      }
    }, function () {
      mount.setAttribute('data-jl-reviews', 'failed');
    });
  }

  function init(scope) {
    var mounts = (scope || document).querySelectorAll('[data-jl-reviews-mount]');
    if (!mounts.length) return;

    if (!('IntersectionObserver' in window)) {
      var startAll = function () {
        for (var i = 0; i < mounts.length; i++) start(mounts[i]);
      };
      if (document.readyState === 'complete') startAll();
      else window.addEventListener('load', startAll, { once: true });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        start(entry.target);
      });
    }, { rootMargin: '200px 0px' });

    for (var j = 0; j < mounts.length; j++) {
      if (!mounts[j].__jlStarted) io.observe(mounts[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
